'use client';
import { Chars, generateToken } from '@basementscripts/token-generator';
import { PUSH_ALERT, REMOVE_ALERT, CLEAR_ALERTS } from './actions';
const pushAlert = (state, payload) => ({
    ...state,
    alerts: [
        ...state.alerts,
        {
            ...payload,
            id: generateToken({ length: 11, type: Chars.AlphaNumericLower, leadWithAlpha: true })
        }
    ]
});
const removeAlert = (state, id) => ({
    ...state,
    alerts: state.alerts.filter((alert) => alert.id !== id)
});
const clearAlerts = (state) => ({
    ...state,
    alerts: []
});
export const reducer = (state, { type, payload }) => {
    switch (type) {
        case PUSH_ALERT:
            return pushAlert(state, payload);
        case REMOVE_ALERT:
            return removeAlert(state, payload);
        case CLEAR_ALERTS:
            return clearAlerts(state);
        default:
            return state;
    }
};
